import Layout from '@/layout'

export default [
	{
		path: '/dataHunter_user',
		name: 'dataHunter_user',
		component: () => import(/* webpackChunkName: "dataHunter_user" */ '@/leniuview/dataHunter/index'),
		hidden: true
	},
	{
		path: '/dataHunter_merchant',
		name: 'dataHunter_merchant',
		component: () => import(/* webpackChunkName: "dataHunter_merchant" */ '@/leniuview/dataHunter_merchant/index'),
		hidden: true
	},
	{
		path: '/auto',
		name: 'auto',
		component: () => import(/* webpackChunkName: "auto" */ '@/leniuview/login/auto'),
		hidden: true
	},
	{
		path: '/yidelogin',
		name: 'yidelogin',
		component: () => import(/* webpackChunkName: "yidelogin" */ '@/leniuview/login/auto3'),
		hidden: true
	},
	{
		path: '/autologin',
		name: 'autologin',
		component: () => import(/* webpackChunkName: "autologin" */ '@/leniuview/login/auto2'),
		hidden: true
	},
	{
		path: '/ddlogin',
		component: () => import('@/leniuview/login/ddlogin'),
		hidden: true
	},
	{
		path: '/mobile/auto/login',
		name: 'mobileautologin',
		component: () => import(/* webpackChunkName: "mobileautologin" */ '@/leniuview/login/autoLogin'),
		hidden: true
	},
	{
		path: '/login',
		name: 'login',
		component: () => import(/* webpackChunkName: "login" */ '@/leniuview/login/index'),
		hidden: true
	},
	{
		path: '/404',
		name: '404',
		component: () => import(/* webpackChunkName: "404" */ '@/leniuview/error/404'),
		hidden: true
	},
	{
		path: '/',
		component: Layout,
		redirect: 'dashboard',
		hidden: true,
		meta: {
			title: 'dashboard',
			icon: 'dashboard'
		},
		children: [
			{
				path: 'dashboard',
				component: () => import(/* webpackChunkName: "dashboard" */ '@/leniuview/dashboard'),
				name: 'Dashboard',
				meta: {
					title: 'dashboard',
					icon: 'dashboard',
					affix: true
				}
			}
		]
	}
]
